import { computed } from 'vue';
import { useSpotStore } from '@/stores/SpotStore';
import { useUserStore } from '@/stores/UserStore';

export const useUserUpgrades = (STORE_ID = null) => {
  const spotStore = useSpotStore(STORE_ID)
  const userStore = useUserStore();

  const upgradeToMemberLevels = {
    '-1': ['plus', 'pro', 'gold'],
    2: ['plus', 'pro', 'gold'],
    46: ['pro', 'gold'],
    49: ['gold']
  };

  const upgradeAvailable = computed(() => spotStore.upgradeAvailable);

  const upgrade = computed(() => {
    let upgradeTo = userStore.memberLevel ? upgradeToMemberLevels[userStore.memberLevel] : []
    let freeTrial = userStore.memberLevel ? userStore.memberLevel === -1 : null

    return [spotStore.upgradeAvailable, upgradeTo, freeTrial, userStore.memberLevel];
  });
  
  const upgradeSpot = computed(() => {
    if (!spotStore.isPro) return upgrade.value;

    let [upgradeAvailable, upgradeTo, freeTrial] = upgrade.value;

    if (userStore.memberLevel <= 46) {
      upgradeTo = upgradeToMemberLevels[46];
    }

    return [upgradeAvailable, upgradeTo, freeTrial, userStore.memberLevel];
  })  

  return {
    upgrade,
    upgradeAvailable,
    upgradeSpot,
    upgradeToMemberLevels
  }
};
